import React, { useState } from "react";
import styles from '../../css/wheater.module.css'

function MountainsCoordinates({ onSelect, click }) {

  const tatry = [
    { name: "Rysy", lat: 49.1793, lon: 20.0885, elv: 2499 },
    { name: "Świnica", lat: 49.2300, lon: 19.9800, elv: 2302 },
    { name: "Kozi Wierch", lat: 49.2292, lon: 20.0758, elv: 2291 },
    { name: "Wysoka", lat: 49.2460, lon: 20.1420, elv: 2547 },
    { name: "Kasprowy Wierch", lat: 49.2318, lon: 19.9815, elv: 1987 },
    { name: "Starorobociański Wierch", lat: 49.1993, lon: 19.8199, elv: 2176 },
    { name: "Łomnica", lat: 49.1650, lon: 20.2791, elv: 2634 },
    { name: "Krywań", lat: 49.1628, lon: 20.0000, elv: 2494 },
    { name: "Gerlach", lat: 49.1667, lon: 20.1333, elv: 2655 },
    { name: "Schronisko d. 5 Stawów", lat: 49.1987, lon: 20.0692, elv: 1670 },
    { name: "Zbojnicka Chata", lat: 49.1766, lon: 20.1676, elv: 1400 },
    { name: "Téryho Chata", lat: 49.1902, lon: 20.1989, elv: 2015 }
  ];

  const kgp = [
    { name: "Śnieżka", lat: 50.7361, lon: 15.7391, elv: 1603 },
    { name: "Babia Góra", lat: 49.6033, lon: 19.5394, elv: 1725 },
    { name: "Tarnica", lat: 49.2222, lon: 22.6767, elv: 1346 },
    { name: "Turbacz", lat: 49.5906, lon: 20.1042, elv: 1310 },
    { name: "Skrzyczne", lat: 49.7111, lon: 19.0319, elv: 1257 },
    { name: "Ślęża", lat: 50.8685, lon: 16.7083, elv: 718 },
    { name: "Wysoka (Pieniny)", lat: 49.4073, lon: 20.5448, elv: 1050 },
    { name: "Łysica", lat: 50.8572, lon: 20.8014, elv: 612 }
  ];


  //Pogoda odrazu dla rysy
  //useEffect(()=>{onSelect(tatry[0]); }, [])


  const renderTiles = (list) =>
    list.map((mountain, i) => (
      <div
        key={i}
        className={styles["mountain-tile"]}
        onClick={() => {
          onSelect(mountain)
          click()
        }}
      >
        {mountain.name}
      </div>
    ));

  return (
    <div className={`${styles["mountains-columns"]} userSelectNone`} >
      
      <p><span>⛰️</span> Tatry</p>
      <div className={styles["mountain-column"]}> 
        {renderTiles(tatry)}
      </div>

      <p> <span>⛰️</span> Inne Szczyty:</p>
      <div className={styles["mountain-column"]}>
        {renderTiles(kgp)}
      </div>

    </div>
  );
}

export default MountainsCoordinates;
